import React from 'react'

interface IBadgeProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode | string
  count?: number
  shape?: 'circle' | 'square'
  showZero?: boolean
  dot?: boolean
  block?: boolean
  variant?: 'default' | 'primary' | 'success' | 'warning'
}

const Badge: React.FC<IBadgeProps> = ({
  children,
  showZero = false,
  count = 0,
  dot,
  block,
  shape = 'circle',
  variant = 'default',
  ...rest
}) => {
  if (dot) {
    return (
      <div className='badge-wrapper' {...rest}>
        <div className={`badge badge-dot badge-${variant}`} />
        {children}
      </div>
    )
  }

  if (!count && !showZero) return <React.Fragment>{children}</React.Fragment>

  return (
    <div className={`badge-wrapper ${block ? 'block' : ''}`} {...rest}>
      <div className={`badge badge-${shape} badge-${variant}`}>
        {count > 100 ? '99+' : count}
      </div>
      {children}
    </div>
  )
}

export default Badge
